import { Lock, Radio, Zap, CreditCard } from 'lucide-react';
import { Button } from '../components/ui/button';

export const SubscriptionGate = ({ onSubscribe, pulseCount, isConfigured = true }) => {
  return (
    <div className="fixed inset-0 z-40 bg-zinc-950/95 backdrop-blur-sm flex items-center justify-center p-4" data-testid="subscription-gate">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Logo */}
        <div className="flex justify-center">
          <div className="w-16 h-16 bg-red-600/20 rounded-2xl flex items-center justify-center">
            <Radio className="w-8 h-8 text-red-500" />
          </div>
        </div>

        {/* Title */}
        <div>
          <h2 className="font-heading text-2xl font-bold text-zinc-100 tracking-tight mb-2">
            Unlock the Private Signal Network
          </h2>
          <p className="text-zinc-400">
            Founding members lock in $7/month
          </p>
        </div>

        {/* Live Pulse Preview */}
        <div className="bg-zinc-900/50 border border-zinc-800 rounded-lg p-4">
          <div className="flex items-center justify-center gap-3">
            <div className="relative">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" />
              <div className="absolute inset-0 w-3 h-3 bg-red-500 rounded-full animate-ping opacity-75" />
            </div>
            <span className="font-mono text-lg text-amber-500 font-bold">{pulseCount}</span>
            <span className="text-sm text-zinc-400">signals in the last 24h</span>
          </div>
        </div>

        {/* Features */}
        <div className="space-y-3 text-left">
          <div className="flex items-center gap-3 text-zinc-300">
            <Zap className="w-5 h-5 text-amber-500 flex-shrink-0" />
            <span>Real-time signal feed from your community</span>
          </div>
          <div className="flex items-center gap-3 text-zinc-300">
            <Zap className="w-5 h-5 text-amber-500 flex-shrink-0" />
            <span>Submit signals about weather, supplies, health & unrest</span>
          </div>
          <div className="flex items-center gap-3 text-zinc-300">
            <Zap className="w-5 h-5 text-amber-500 flex-shrink-0" />
            <span>Push notifications for alerts in your area</span>
          </div>
          <div className="flex items-center gap-3 text-zinc-300">
            <Zap className="w-5 h-5 text-amber-500 flex-shrink-0" />
            <span>Filter by category, city, and country</span>
          </div>
        </div>

        {/* Pricing */}
        <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
          <div className="text-3xl font-bold text-zinc-100 mb-1">
            $7<span className="text-lg text-zinc-500 font-normal">/month</span>
          </div>
          <p className="text-sm text-zinc-500">Cancel anytime</p>
        </div>

        {/* CTA */}
        {isConfigured ? (
          <Button
            onClick={onSubscribe}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-4 rounded-lg text-lg flex items-center justify-center gap-2"
            data-testid="subscribe-btn"
          >
            <CreditCard className="w-5 h-5" />
            Subscribe Now
          </Button>
        ) : (
          <div className="space-y-3">
            <Button
              disabled
              className="w-full bg-zinc-700 text-zinc-400 font-semibold py-4 rounded-lg text-lg flex items-center justify-center gap-2 cursor-not-allowed"
              data-testid="subscribe-btn-disabled"
            >
              <Lock className="w-5 h-5" />
              Payments Coming Soon
            </Button>
            <p className="text-xs text-zinc-500">
              Stripe integration not yet configured
            </p>
          </div>
        )}

        <p className="text-xs text-zinc-600">
          Secure payment powered by Stripe
        </p>
      </div>
    </div>
  );
};
